<template>
  <div class="apply-wrapper">
    <div class="apply-title">
      <div class="title-underline"></div>
      まずは無料で会員登録
    </div>
    <div class="apply-input-wrapper">
      <div class="apply-content-wrapper">
        <div class="input-field-title">お名前（アルファベット表記）</div>
        <div class="input-field-wrapper">
          <v-text-field
            v-model="name"
            solo
            flat
            placeholder="例：FONDI TARO"
            :error-messages="nameErrors"
          ></v-text-field>
        </div>
        <div class="input-field-title">登録用Emailアドレス</div>
        <div class="input-field-wrapper">
          <v-text-field
            v-model="email"
            solo
            flat
            placeholder="例：fondi_email@fondi.com"
            :error-messages="emailErrors"
            height="40"
          ></v-text-field>
        </div>
        <div class="input-field-title">希望レッスン時間</div>
        <div class="input-field-wrapper">
          <v-select
            v-model="timeIndex"
            :items="timeOptions"
            :menu-props="{ bottom: true, offsetY: true }"
            flat
            solo
            placeholder="ご希望のレッスン時間を選択してください。"
          >
            <template #append>
              <div class="v-input__icon v-input__icon--append">
                <v-icon size="48" color="rgb(219, 219, 219)">mdi-chevron-down</v-icon>
              </div>
            </template>
          </v-select>
        </div>
        <div class="input-field-alert">
          ※レッスンの予約は時間固定です。曜日によって時間の調整は出来ません。<br />
          　レッスンに参加出来なくなった場合はアプリ側からキャンセルをお願い致します。
        </div>
        <div class="apply-btn-wrapper">
          <button class="btn-apply btn-shrink" :disabled="!valid" @click="apply()">
            無料会員登録
          </button>
        </div>
      </div>
    </div>

    <v-dialog v-model="dialog" persistent max-width="300px">
      <v-card class="text-center" pa-4>
        <v-card-text>
          <v-progress-circular
            v-show="dialogLoading"
            indeterminate
            color="primary"
          ></v-progress-circular>
          <div class="mt-2 text-center">{{ dialogMessage }}</div>
        </v-card-text>
        <v-card-actions v-show="dialogClosable">
          <v-spacer></v-spacer>
          <v-btn color="gray" @click="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
const kDialogMessageLoading = 'Loading...';
const kDialogMessageError = 'エラーが発生しました。';
const kDialogMessageSuccess = '申し込みが完了しました。\nご登録のEメールをご確認ください。';
const kNameEmptyError = '名前を入力してください。';
const kEmailEmptyError = 'Emailを入力してください。';

export default {
  data() {
    return {
      email: '',
      name: '',
      timeIndex: undefined,
      emailErrors: [kEmailEmptyError],
      nameErrors: [kNameEmptyError],
      timeOptions: [
        { value: 0, text: '09:00~09:25' },
        { value: 1, text: '09:30~09:55' },
        { value: 2, text: '10:00~10:25' },
        { value: 3, text: '10:30~10:55' },
        { value: 4, text: '11:00~11:25' },
        { value: 5, text: '11:30~11:55' },
        { value: 6, text: '12:00~12:25' },
        { value: 7, text: '12:30~12:55' },
        { value: 8, text: '13:00~13:25' },
        { value: 9, text: '13:30~13:55' },
        { value: 10, text: '14:00~14:25' },
        { value: 11, text: '14:30~14:55' },
        { value: 12, text: '15:00~15:25' },
        { value: 13, text: '15:30~15:55' },
        { value: 14, text: '16:00~16:25' },
        { value: 15, text: '16:30~16:55' },
        { value: 16, text: '17:00~17:25' },
        { value: 17, text: '17:30~17:55' },
        { value: 18, text: '18:00~18:25' },
        { value: 19, text: '18:30~18:55' },
        { value: 20, text: '19:00~19:25' },
        { value: 21, text: '19:30~19:55' },
        { value: 22, text: '20:00~20:25' },
        { value: 23, text: '20:30~20:55' },
        { value: 24, text: '21:00~21:25' },
        { value: 25, text: '21:30~21:55' },
        { value: 26, text: '22:00~22:25' },
        { value: 27, text: '22:30~22:55' },
      ],
      dialog: false,
      dialogClosable: false,
      dialogLoading: false,
      dialogMessage: kDialogMessageLoading,
    };
  },

  computed: {
    valid() {
      return this.name && this.email && this.timeIndex !== undefined;
    },
  },

  watch: {
    email(email) {
      if (email.length == 0) {
        this.emailErrors = [kEmailEmptyError];
        return;
      }
      this.emailErrors = [];
    },

    name(name) {
      if (name.length == 0) {
        this.nameErrors = [kNameEmptyError];
        return;
      }
      this.nameErrors = [];
    },
  },

  methods: {
    async apply() {
      if (!this.valid) {
        this.showFieldErrors();
        return;
      }

      this.dialog = true;
      this.dialogLoading = true;
      this.dialogClosable = false;
      this.dialogMessage = kDialogMessageLoading;

      try {
        await axios.post('study-program/register', {
          name: this.name,
          email: this.email,
          time: this.timeIndex,
        });

        this.dialogLoading = false;
        this.dialogClosable = true;
        this.dialogMessage = kDialogMessageSuccess;
        this.clearField();
      } catch (e) {
        if (e.response) {
          if (e.response.status == 422) {
            this.dialog = false;
            this.emailErrors = e.response.data.email;
            this.nameErrors = e.response.data.name;
          } else {
            this.dialogLoading = false;
            this.dialogMessage = e.response.data;
            this.dialogClosable = true;
          }
        } else {
          this.dialogLoading = false;
          this.dialogMessage = kDialogMessageError;
          this.dialogClosable = true;
          throw e;
        }
      }
    },

    showFieldErrors() {
      if (!this.email) {
        this.emailErrors = [kEmailEmptyError];
      }

      if (!this.name) {
        this.nameErrors = [kNameEmptyError];
      }
    },

    async clearField() {
      this.name = '';
      this.email = '';
      this.timeIndex = undefined;

      // Wait until the view is refreshed.
      await new Promise((resolve) => setTimeout(resolve, 500));
      setTimeout(() => {
        this.emailErrors = [];
        this.nameErrors = [];
      }, 500);
    },
  },
};
</script>

<style scoped>
.apply-wrapper {
  margin-top: 100px;
  position: relative;
}
.apply-title {
  font-weight: bold;
  color: #655940;
  font-size: 46px;
  text-align: center;
  position: relative;
  width: max-content;
  margin: 0 auto;
}
.title-underline {
  background-image: url('/img/lp/lpTextUnderLineMiddle.png');
  background-size: contain;
  background-position: right bottom;
  position: absolute;
  left: -15%;
  right: -20%;
  top: 0;
  bottom: -4px;
}
.apply-input-wrapper {
  width: 680px;
  margin: 0 auto;
}
.apply-content-wrapper {
  padding-top: 78px;
}
.input-field-title {
  font-size: 32px;
  color: #625d53;
  font-weight: bold;
  margin-top: 36px;
}
.input-field-wrapper {
  margin-top: 4px;
  padding: 4px 20px 0;
  background-color: #fff;
  height: 56px;
}
.input-field-alert {
  margin-top: 12px;
  font-size: 16px;
  font-weight: bold;
  line-height: 1.4em;
  color: rgb(255, 71, 41);
}
.apply-btn-wrapper {
  padding: 120px 0;
  text-align: center;
}
.btn-apply {
  background-image: url('/img/lp/lpBtnPrimaryNomal.png');
  background-size: cover;
  width: 480px;
  height: 90px;
  font-size: 36px;
  font-weight: bold;
  color: #fff;
  outline: none;
}
.btn-apply:hover:not(:disabled) {
  background-image: url('/img/lp/lpBtnPrimaryHover.png');
}
.btn-apply:disabled {
  opacity: 0.6;
}
@media (max-width: 767px) {
  .apply-wrapper {
    margin-top: 50px;
    position: relative;
  }
  .apply-title {
    font-size: 28px;
  }
  .apply-input-wrapper {
    width: 330px;
  }
  .apply-content-wrapper {
    padding-top: 10px;
  }
  .v-input {
    font-size: 12px;
  }
  .input-field-title {
    font-size: 16px;
    margin-top: 32px;
  }
  .input-field-alert {
    font-size: 10px;
    transform: scale(0.8);
    width: 125%;
    margin-left: -12.5%;
    margin-top: 4px;
  }
  .apply-btn-wrapper {
    padding: 35px 0 70px;
  }
  .input-field-wrapper {
    padding-left: 0;
    padding-right: 0;
  }
  .btn-apply {
    width: 240px;
    height: 45px;
    font-size: 18px;
  }
}
@media (max-width: 480px) {
  .apply-title {
    font-size: 21px;
  }
}
@media (max-width: 360px) {
  .apply-title {
    font-size: 18px;
  }
  .apply-input-wrapper {
    width: 300px;
  }
  .input-field-alert {
    transform: scale(0.7);
    width: 140%;
    margin-left: -20%;
    margin-top: 0;
  }
}
</style>
